import { render } from "./InstanceSummary.vue?vue&type=template&id=56ad6a62&scoped=true"
import script from "./InstanceSummary.vue?vue&type=script&lang=js"
export * from "./InstanceSummary.vue?vue&type=script&lang=js"

import "./InstanceSummary.vue?vue&type=style&index=0&id=56ad6a62&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ad6a62"]])

export default __exports__